<template>
  <li
    v-if="flashcard"
    :class="{ locked }"
  >
    <span
      class="search-result"
      @click="handleClick"
    >
      <div>
        <p class="categories">
          {{ flashcardCategoryText }}
        </p>
        <p class="question-content">
          {{ stripHtml(flashcard.question) }}
        </p>
      </div>
      <icon
        v-if="locked"
        name="lock"
        variant="333333"
      />
    </span>
  </li>
</template>

<script>
import Icon from '@components/singletons/icon';
import QuestionsUiV2Mixin from '@/mixins/questions-ui-v2';

import { stripHtml } from '@/utils';

export default {
  components: { Icon },
  mixins: [QuestionsUiV2Mixin],
  props: {
    flashcard: {
      type: Object,
    },
    flashcardCategoryText: {
      type: String,
      default: '',
    },
    flashcardRoute: {
      type: Object,
    },
    locked: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['clicked-result'],
  computed: {
    accessibleCategories() {
      return this.flashcard.categories
        .filter(c => this.$access(this.$store, 'category', c.id))
        .map(c => this.$store.getters['categories/categories'][c.id]);
    },
    firstFlashcardCategory() {
      let types = this.$store.getters['categoryTypes/multipleChoiceCategoryTypes'].map(ct => ct.id);
      return this.accessibleCategories.find(c => {
        return types.includes(c.categoryTypeId);
      });
    },
  },
  methods: {
    stripHtml,
    handleClick() {
      if (this.questionUiV2Enabled) {
        this.setLearningPath(this.flashcard);
        this.$emit('clicked-result', this.flashcard, 'Flashcard', this.locked);
        return this.$router.push({
          name: 'learningPath#show',
          params: { flashcardId: this.flashcard.id, categoryId: this.categoryId },
        });
      } else {
        this.$emit('clicked-result', this.flashcard, 'Flashcard', this.locked);
        return this.$router.push(this.flashcardRoute);
      }
    },
    setLearningPath(flashcard) {
      this.$store.commit('learningPath/setFlashcards', [{
        categoryId: this.firstFlashcardCategory.id,
        flashcardId: flashcard.id,
      }]);
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  margin-bottom: rem-calc(36);
  padding: rem-calc(16);

  @include breakpoint(small) {
    margin-bottom: rem-calc(24);
  }

  &.locked {
    opacity: 0.4;
  }

  &:not(.locked) {
    .search-result {
      margin-right: rem-calc(42);
    }
  }

  .search-result {
    align-items: center;
    color: #333333;
    display: flex;
    cursor: pointer;

    .categories {
      font-size: rem-calc(10);
      margin-top: 0;
      margin-bottom: rem-calc(4);
      text-transform: uppercase;
    }

    .question-content,
    .question-content p {
      display: -webkit-box;
      font-size: rem-calc(14);
      height: rem-calc(32);
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }

    img {
      height: rem-calc(18);
      width: rem-calc(18);
      padding-left: rem-calc(24);
      flex-shrink: 0;
    }
  }
}
</style>
